module.exports = __webpack_public_path__ + "img/h_s1e1_interactions_1.8ca28e0b.png";